module.exports = __webpack_public_path__ + "img/clive-pro.879134fd.jpg";